import { Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'
import type { FC } from 'react'

import { COLORS } from '@hcr/ui'

interface YearHeadingProps {
  sx?: SxProps<Theme>
  year: string
}

export const getYearHeadingId = (year: string) => `weeks-preview-year-${year}`

export const YearHeading: FC<YearHeadingProps> = ({ sx, year }) => (
  <Typography id={getYearHeadingId(year)} component='h2' color={COLORS.burgundi[500]} variant='displayS' sx={sx}>
    {year}
  </Typography>
)
